import { useMedia } from './useMedia.js'

export function useIsMobile() {
  return useMedia('(max-width: 742px)')
}
